import React, { useState } from 'react'
import { Container, Row, Col } from "react-bootstrap";
import "./FrontText.css"
import ImageFront from '../ImageFront/ImageFront';
import { FaLinkedin, FaGithub } from "react-icons/fa";
import { SiGmail } from "react-icons/si";
import { useHighlight } from '../ContextProviders/HighlightContext';

const FrontText = () => {
    
    const openInNewTab = (url) => {
        window.open(url, "_blank", "noopener,noreferrer");
    };
    
    const link1 = "https://www.linkedin.com/in/aelohim/";
    const link2 = "https://github.com/aeloh1m";
    const link3 = "mailto:agraizzarodev@gmail.com";
    
    // Highlight
    
    const { highlight } = useHighlight();
    

    return (

        <Container fluid className='py-3'>
            <Row>
                <Col>
                    <Container>
                        <ImageFront></ImageFront>
                        <div class="front-text">

                            <div class="typing-demo">Aelohim Graizzaro</div>

                            <p className="software-dev" >Senior Software Developer</p>
                        </div>


                    </Container>
                    <Container fluid className='logos-contact'>
                        <ul className={highlight  ? 'logos-ul-highlight' : 'logos-ul'}>
                            <li className='logos-li'>
                                <FaLinkedin onClick={() => openInNewTab(link1)} ></FaLinkedin>

                            </li>
                            <li className='logos-li'>
                                <FaGithub onClick={() => openInNewTab(link2)} ></FaGithub>

                            </li>
                            <li className='logos-li'>
                                <div>

                                    <SiGmail onClick={() => openInNewTab(link3)} ></SiGmail>

                                </div>

                            </li>
                            <li></li>
                            <li></li>


                        </ul>


                    </Container>


                </Col>
            </Row>
        </Container>


    )
}

export default FrontText
